import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { DialogFooter, type TActionButton } from "@surfaces/DialogFooter";

export interface IMultiItemNavigationFooterProps {
  isFirst: boolean;
  isLast: boolean;
  cancelLabel: string;
  confirmLabel: string;
  onCancel: () => void;
  onPrevious: () => void;
  onNext: () => void;
  onConfirm: () => void;
  disabled?: boolean;
}

export const MultiItemNavigationFooter = ({
  isFirst,
  isLast,
  cancelLabel,
  confirmLabel,
  onCancel,
  onPrevious,
  onNext,
  onConfirm,
  disabled = false,
}: IMultiItemNavigationFooterProps) => {
  const actions: TActionButton[] = [{ label: cancelLabel, startIcon: <CloseIcon />, onClick: onCancel, disabled }];

  if (!isFirst) {
    actions.push({ label: "Précédent", startIcon: <NavigateBeforeIcon />, onClick: onPrevious, disabled });
  }

  actions.push(
    isLast
      ? { label: confirmLabel, startIcon: <CheckCircleOutlined />, onClick: onConfirm, variant: "contained", disabled }
      : { label: "Suivant", endIcon: <NavigateNextIcon />, onClick: onNext, variant: "contained", disabled }
  );

  return <DialogFooter actions={actions} />;
};
